import { render, staticRenderFns } from "./DetailProject.vue?vue&type=template&id=ae99a07a&"
import script from "./DetailProject.vue?vue&type=script&lang=js&"
export * from "./DetailProject.vue?vue&type=script&lang=js&"
import style0 from "./DetailProject.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DetailProject.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports